import React, {Fragment, Component } from 'react'
import store from '../store'
import Adsimple from '../components/adsimple'
class Customer extends Component{
  constructor(props){
    super(props);
    this.state = store.getState();
    this.handleStoreChange = this.handleStoreChange.bind(this);
    store.subscribe(this.handleStoreChange);
  }
  render(){
    return(
      <Fragment>
        <div className='m1top center960'>
          <img className='m1img' src={this.state.customerpic} alt='pictures' />
        </div>
        <div ></div>
        {this.state.customers.map((item,index)=>{
          return <Adsimple picsrc={item} link='/customer' key={index} />
        })}
      </Fragment>
    )
  }
  handleStoreChange() {
    this.setState(store.getState());
  }
}
export default Customer;